// The user's preferred vertical spacing between per-lead median beat tiles
// in single-column mode. Range [0.0, 1.0], default 1.0 (no overlap).
// Persisted to localStorage so it survives page reloads and recording
// switches; the slice seeds `settings.medianBeatVerticalSpacing` from here
// and writes back on every `setMedianBeatVerticalSpacing`.
const STORAGE_KEY = "annotatorMedianBeatVerticalSpacing"
const DEFAULT_VALUE = 1.0

export const getPersistedMedianBeatVerticalSpacing = () => {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY)
        if (raw == null) return DEFAULT_VALUE
        const parsed = parseFloat(raw)
        if (!Number.isFinite(parsed)) return DEFAULT_VALUE
        // Clamp to the supported range in case an older or manually-edited
        // value falls outside it.
        return Math.min(1, Math.max(0, parsed))
    } catch {
        return DEFAULT_VALUE
    }
}

export const setPersistedMedianBeatVerticalSpacing = (value) => {
    try {
        const clamped = Math.min(1, Math.max(0, Number(value)))
        window.localStorage.setItem(STORAGE_KEY, String(clamped))
    } catch {
        // localStorage can throw (private browsing, quota) — safe to ignore;
        // the in-memory Redux value is still authoritative for this session.
    }
}
